import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Box,
  Stack,
  InputLabel,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
} from '@mui/material';
import Loader from '../../common/Loader';
// import CustomersFormattedMessages from '../../../messages/admin/CustomersFormattedMessages';

// NETWORKING
import useComplianceRequest from '../../../requests/ComplianceRequest';

const Regular = ({ errorHandler, navigate }) => {
  const [regular, setRegular] = useState(null);
  const [regularSearch, setRegularSearch] = useState('');

  const { getCampaignManagementRegular } = useComplianceRequest();

  useEffect(() => {
    const fetchRegular = async () => {
      const regularData = await getCampaignManagementRegular(errorHandler);
      console.log('regular data:', regularData);
      setRegular(regularData);
    };
    fetchRegular();
  }, []);

  /*
    Handles changes in the form
  */
  const handleRegularSearchChange = async (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setRegularSearch(value);
  };

  const handleSearch = async (updatedSearch) => {
    try {
      setRegular(null);
      console.log('searching for:', updatedSearch);
      const issuesData = await getCampaignManagementRegular(
        errorHandler,
        updatedSearch
      );
      setRegular(issuesData);
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleKeyDown = async (event) => {
    const { key } = event;
    if (key === 'Enter') handleSearch(regularSearch);
  };

  const generateRegularCustomersTable = () => {
    let tableContent = (
      <TableRow key={null}>
        <TableCell>
          <Loader />
        </TableCell>
      </TableRow>
    );

    if (regular) {
      tableContent = regular.map((customer) => {
        return (
          <TableRow key={customer.customer_id}>
            <TableCell>
              <Link
                onClick={() => {
                  navigate('/admin/customers/' + customer.customer_id);
                }}
                tabIndex={0}
              >
                {customer.customer_name}
              </Link>
            </TableCell>
            <TableCell>
              <Link
                onClick={() => {
                  navigate('/admin/compliance/brand/' + customer.brand_id);
                }}
                tabIndex={0}
              >
                {customer.brand_code}
              </Link>
            </TableCell>
            <TableCell>{customer.campaign_count}</TableCell>
            <TableCell>{customer.brand_identity_status}</TableCell>
            <TableCell>{customer.vertical}</TableCell>
            <TableCell>{customer.entity_type}</TableCell>
          </TableRow>
        );
      });
    }

    return (
      <Box>
        <TableContainer
          sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}
        >
          <Table variant="rounded">
            <TableHead>
              <TableRow key="head">
                <TableCell>{'Customer Name'}</TableCell>
                <TableCell>{'Brand Code'}</TableCell>
                <TableCell>{'Campaigns'}</TableCell>
                <TableCell>{'Status'}</TableCell>
                <TableCell>{'Vertical'}</TableCell>
                <TableCell>{'Entity Type'}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tableContent}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          backgroundColor: 'common.white',
          borderRadius: '0 0 20px 20px',
          paddingX: 4,
          paddingY: 2,
          maxWidth: 800,
        }}
      >
        <Stack
          sx={{
            flexDirection: { md: 'row' },
            justifyContent: 'space-between',
            alignItems: { md: 'center' },
            gap: 2,
          }}
        >
          <Stack sx={{ flex: 1 }}>
            <InputLabel>{'Search by customer name, brand code'}</InputLabel>

            <Stack sx={{ flex: 1, flexDirection: 'row', gap: 2 }}>
              <TextField
                id="contactSearch"
                autoFocus
                type="text"
                name="searchContent"
                onKeyDown={handleKeyDown}
                onChange={handleRegularSearchChange}
                variant="outlined"
                fullWidth
                size="small"
              />

              <Button
                variant="outlined"
                color="secondary"
                name="submit"
                onClick={() => handleSearch(regularSearch)}
              >
                Search
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      {generateRegularCustomersTable()}
    </React.Fragment>
  );
};

export default Regular;
